var SlidersBetweenPages = function(){
    
    function logosSlider(){
            
        if(!isMobile && $('.city_slider').length) {
            var width = $('.city_slider').width();
            document.querySelector(".city_slider-section .swiper-container").style.width = width - 80 + 'px';
        }

        var swiperLogos = new Swiper('.city_slider-section .swiper-container', {
            slidesPerView: 5,
            spaceBetween: 20,
            loop: true,
            navigation: {
                nextEl: '.city_slider-section .swiper-button-next',
                prevEl: '.city_slider-section .swiper-button-prev',
            },
            breakpoints: {
                550: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                },
                750: {
                    slidesPerView: 4,
                },
                850: {
                    slidesPerView: 5,
                }
            }
        });
    }

    function productsSlider(){
        
        if(!isMobile && $('.slider_products').length) {
            var width = $('.slider_products').width();
            sliderSelector = document.querySelectorAll(".slider_products .swiper-container");
            $.each(sliderSelector, function(i, slider) {
                slider.style.width = width - 80 + 'px';
            });
        }

        var swiperProducts = new Swiper('.slider_products .swiper-container', {
            slidesPerView: 4,
            spaceBetween: 10,
            loop: true,
            navigation: {
                nextEl: '.slider_products .swiper-button-next',
                prevEl: '.slider_products .swiper-button-prev',
            },
            breakpoints: {
                700: {
                    slidesPerView: 3,
                },
                550: {
                    slidesPerView: 2,
                }
            }
        });
        swiperProducts.on('touchEnd', function(){
            bLazy.revalidate();
        });
    }

    function slidersEvents() {
        $(document).on("click", ".vr-mobile-body__wrap .city_slider-logo a", function(){
            var brand_name = $(".vr-header__label-btn_close").attr("href").split("/").pop();
            ga('send', 'event', { eventCategory: 'brochure-view-' + (isMobile ? 'mobile' : 'desktop'), eventAction: 'mark-logo-slider', eventLabel: brand_name +"-"+ $(this).attr("href")});
        });
        $(document).on("click", ".vr-mobile-body__wrap .city_slider-section .swiper-button-next", function(){
            ga('send', 'event', { eventCategory: 'brochure-view-' + (isMobile ? 'mobile' : 'desktop'), eventAction: 'mark-slider-arrow', eventLabel: "right"});
            bLazy.revalidate();
        });
        $(document).on("click", ".vr-mobile-body__wrap .city_slider-section .swiper-button-prev", function(){
            ga('send', 'event', { eventCategory: 'brochure-view-' + (isMobile ? 'mobile' : 'desktop'), eventAction: 'mark-slider-arrow', eventLabel: "left"});
            bLazy.revalidate();
        });
        $(document).on("click", ".slider_products .city_product-logo a", function(){
            ga('send', 'event', { eventCategory: 'brochure-view-' + (isMobile ? 'mobile' : 'desktop'), eventAction: 'product-slider-mark-over-product', eventLabel: $(this).attr('title')});
        });
        $(document).on("click", ".slider_products .city_product-photo a", function(){
            var brand_name = $(".vr-header__label-btn_close").attr("href").split("/").pop(),
                product_name = $(this).closest(".city_product").find(".city_product-bottom-title a").text(),
                product_brand_name = $(this).closest(".city_product").find(".city_slider-logo a").attr("title");
            ga('send', 'event', { eventCategory: 'brochure-view-' + (isMobile ? 'mobile' : 'desktop'), eventAction: 'product-slider', eventLabel: brand_name +"-"+ product_name + "-" + product_brand_name});
        });
        $(document).on("click", ".slider_products .swiper-button-next", function(){
            ga('send', 'event', { eventCategory: 'brochure-view-' + (isMobile ? 'mobile' : 'desktop'), eventAction: 'product-slider-arrow', eventLabel: 'right'});
            bLazy.revalidate();
        });
        $(document).on("click", ".slider_products .swiper-button-prev", function(){
            ga('send', 'event', { eventCategory: 'brochure-view-' + (isMobile ? 'mobile' : 'desktop'), eventAction: 'product-slider-arrow', eventLabel: 'left'});
            bLazy.revalidate();
        });
    }

    function navigationEvents() {
        var ec = 'brochure-view-' + (isMobile ? 'mobile' : 'desktop'),
            el = window.location.host + window.location.pathname;

        $(document).on("click", ".view_navigation a", function(e){
            if($(this).hasClass('first-page')) {
                ga('send', 'event', { eventCategory: ec, eventAction: 'first-page-click', eventLabel: el });
            }
            if($(this).hasClass('js-vr-last-page-btn')) {
                ga('send', 'event', { eventCategory: ec, eventAction: 'last-page-click', eventLabel: el });
            }
            if($(this).hasClass('next-page')) {
                ga('send', 'event', { eventCategory: ec, eventAction: 'next-page-click', eventLabel: el });
            }
            if($(this).hasClass('prev-page')) {
                ga('send', 'event', { eventCategory: ec, eventAction: 'prev-page-click', eventLabel: el });
            }
        });
    }

    function init(){
        logosSlider();
        productsSlider();
        slidersEvents();
        navigationEvents();

        $(document).on("click", ".view_navigation .next-page, .view_navigation .prev-page", function(){
            var y = $(window).scrollTop();

            if($(this).hasClass("next-page")) {
                isMobile ? $(window).scrollTop(y+(window.innerHeight+94)*0.7) : $(window).scrollTop(y+(window.innerHeight-60)*0.7);
            } else {
                isMobile ? $(window).scrollTop(y-(window.innerHeight+94)*0.7) : $(window).scrollTop(y-(window.innerHeight-60)*0.7);
            }
        });

        $(document).on("click", ".view_navigation .first-page", function(){
            $(window).scrollTop(0);
        });

        $(document).on("click", ".view_navigation .js-vr-last-page-btn", function(){
            var html = document.querySelector("html");
            html.style.scrollBehavior = "auto";
            setTimeout(function(){
                html.style.scrollBehavior = "smooth";
            }, 50);
        });
    }

    this.init = init;
}